import { Link } from 'react-router';
import { SectionTitle } from '../../components/typography/Heading';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import Image from '../../components/image/Image';
import styles from './campaign-banner.module.less';

export const Campaign = ({ name, title, description, image, link, trackingLocation }) => {
    const imageIsSvg = image?.includes('.svg');
    return description ? (
        <Link
            onClick={() => trackEvent('campaign', name, { action: 'click', trackingLocation })}
            className={styles.campaignContainer}
            to={link}
        >
            <Image
                className={styles.image}
                src={imageIsSvg ? image : `${image}?w=400&fm=webp`}
                alt=""
                role="presentation"
                loading={'lazy'}
            />
            <div className={styles.campaignTextContainer}>
                <SectionTitle tag={'h3'} className={styles.campaignTitle}>
                    {title}
                </SectionTitle>
                <p className={styles.campaignDescription}>{description}</p>
            </div>
        </Link>
    ) : (
        <Link className={styles.smallCampaignContainer} to={link}>
            <Image
                className={styles.image}
                src={imageIsSvg ? image : `${image}?w=400&fm=webp`}
                alt=""
                loading={'eager'}
                role="presentation"
            />
            <span className={styles.campaignName}>{name}</span>
        </Link>
    );
};
